import React from "react";
import { Switch, Route } from "react-router-dom";
import SafetyDashboard from "./Index";

export default () => (
  <Switch>
    <Route path="/safety_dashboard" component={SafetyDashboard} />
  </Switch>
);
